import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { BannerContainer } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/modalBanner.styles';

const ManagerViewPendingEmployeeConsentBanner = () => (
  <BannerContainer themeColor={ThemeColorType.iconGray}>
    <Text14 themeColor={ThemeColorType.white} semiBold>
      {gettext('Timesheet has been edited.')}
    </Text14>

    <div>
      <Text14 themeColor={ThemeColorType.white} semiBold>
        {gettext(`Pending employee's consent.`)}
      </Text14>
    </div>
  </BannerContainer>
);

export default ManagerViewPendingEmployeeConsentBanner;
